import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvoicesService } from 'src/app/services/invoices.service';

@Component({
  selector: 'ap-invoice-delete-dialog',
  templateUrl: 'invoice-delete.dialog.html',
  styleUrls: ['./invoice-delete.dialog.scss']
})
export class InvoiceDeleteDialogComponent {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: { invoice: { number: number } },
      public dialog: MatDialog,
      private invoiceService: InvoicesService
      ) {}

      delete() {
        this.invoiceService.deleteOne(this.data.invoice.number).subscribe(r => {
          this.dialog.closeAll();
        });
      }

}
